<template>
    <div class="row">
        <div class="col-md-12">
             <div class="row justify-content-center align-items-center min-vh-100">
                <div class="col-md-12">
                  <div class="d-flex justify-content-center login" >
                    <div class="align-self-center flex-grow-1"  style="max-width: 390px;" >
                        
                        <h4 class="text-center mb-4">Create your account</h4>
                        <form @submit.prevent="register($event)">
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <input id="email" type="email" class="form-control form-control-lg" name="email" v-model="form.email"  placeholder="Email" required autocomplete="email" autofocus>
                                </div>
                            </div>

                            <div class="form-group row  p-2">
                                <div class="col-md-12">
                                    <input id="password" type="password" class="form-control form-control-lg " name="password" v-model="form.password"  placeholder="Password" required autocomplete="current-password">
                                </div>
                            </div>
                            <div class="form-group">
                              <vue-recaptcha ref="recaptcha" class="g-recaptcha"  @verify="onVerify" @expired="onExpired" :sitekey="recaptcha_key" :loadRecaptchaScript="true"></vue-recaptcha>
                            </div>
                            <div class="form-group row  p-2 mb-0">
                                <div class="col-md-12 text-center">
                                    <button type="submit" class="btn btn-primary btn-block register-btn">
                                        Create Account
                                    </button>
                                     <p class="mt-3 mb-0">Already haven account? <a href="/login">Login</a></p>
                                    
                                </div>
                            </div>
                        </form>
                    </div>
                  </div>
                
                 </div>
             </div>
       
           
        </div>
    </div>
</template>
<script>
 import VueRecaptcha from 'vue-recaptcha';

  export default {
    props: ['recaptcha_key'],
    components: { VueRecaptcha },
    data() {
      return {
        form: {},
        //show_recaptcha: false
      };
    },
    mounted() {
        // if(localStorage.show_recaptcha && localStorage.show_recaptcha == true){
        //   this.show_recaptcha = true;
        // } else {
        //   this.show_recaptcha = false;
        // }
    },
    methods: {
      register(){

        $('.register-btn').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary').prop('disabled', true);

        const formData = new FormData();
        formData.append('email', this.form.email);
        formData.append('password', this.form.password);
        //if(this.show_recaptcha == true){
          formData.append('g_recaptcha_response', this.form.g_recaptcha_response);
        //}

        axios.post('/register',formData).then( response=> {

          this.$refs.recaptcha.reset();

          //localStorage.show_recaptcha = false;

          $('.register-btn').html('Create Account').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
          $.notify(response.data.message,{
              type: 'success',
              placement: {
                  from: 'top',
                  align: 'center'
              },
              delay: 999999,
          });
        }).catch(error=>{

          this.$refs.recaptcha.reset();

          // if(this.show_recaptcha == false){
          //   localStorage.show_recaptcha = true;
          //   this.show_recaptcha = true;
          // }

          $('.register-btn').html('Create Account').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
          $.notify(JSON.parse(error.request.response).message,{
              type: 'danger',
              placement: {
                  from: 'top',
                  align: 'center'
              },
              delay: 999999,
          });
        });
      },
      onVerify: function (response) {
        this.form.g_recaptcha_response = response;
      },
      onExpired: function () {
        console.log('Expired')
      }
    }
  }
</script>
